import Swiper from 'swiper'
import { Autoplay, Pagination, Parallax } from 'swiper/modules'

const hero = {
  el: {
    hero: document.querySelector<HTMLElement>('.hero'),
    swiper: document.querySelector<HTMLElement>('.hero__swiper'),
    swiperPagination: document.querySelector<HTMLElement>('.hero__swiper-pagination'),
    swiperSlides: document.querySelectorAll<HTMLElement>('.hero__swiper-slide'),
  },

  init(): void {
    if (!this.el.hero) {
      return
    }

    if (this.el.swiper) {
      this.initSwiper()
    }
  },

  initSwiper(): void {
    new Swiper(this.el.swiper, {
      // autoHeight: true,
      autoplay: {
        delay: 2345,
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
      },
      grabCursor: this.el.swiperSlides.length > 1,
      initialSlide: 0, // el.slides.length > 1 ? gsap.utils.random(0, el.slides.length - 1) : 0,
      loop: this.el.swiperSlides.length > 1,
      modules: [Autoplay, Pagination, Parallax],
      pagination: {
        bulletActiveClass: 'hero__swiper-pagination-bullet--active',
        bulletClass: 'hero__swiper-pagination-bullet',
        bulletElement: 'button',
        clickable: true,
        el: this.el.swiperPagination,
        renderBullet: (index, className) => `<button class='${className}' title='Review no. ${index + 1}'>Review no. ${index + 1}</button>`,
        type: 'bullets',
      },
      parallax: this.el.swiperSlides.length > 1,
      slidesPerView: 1,
      spaceBetween: 40,
      speed: 456,
    })
  },
}

export default hero
